
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqYfu2AWB8IxcjYRpy3wfXaf7X1a5C3aGnOp5CZNI1c4Meta } from "/vercel/path1/pages/index.vue?macro=true";
import { default as _91slug_93wgRfnMXetsUgStiblJa41ZWiJv0pSTWb0UvNB_45Cn2DIMeta } from "/vercel/path1/pages/[slug].vue?macro=true";
import { default as distributorxvNRXIvQdbrmdJox47oVmiZsFviYRPj7OVkZAt_BaQkMeta } from "/vercel/path1/pages/distributor.vue?macro=true";
import { default as find_45a_45dealer83CnZwIsxFSL2SWjt9tlfN8jG2e19fGwme2R0WGxUcgMeta } from "/vercel/path1/pages/find-a-dealer.vue?macro=true";
import { default as _91slug_93TXeGdL_45BWjvykMzKsv_AI8SesWxJ06RzPSs4ZHgRmiYMeta } from "/vercel/path1/pages/products/[slug].vue?macro=true";
import { default as _91slug_93OCF16c3YD1nRpxt_45pOCgJYwnKEojmJ6TKNSs2GRS8O4Meta } from "/vercel/path1/pages/community/[slug].vue?macro=true";
import { default as set_45up_45maintenancece2pklUrgYIS8CXdR8fqxl_45gC_ZqujMRxCBnTPzLVMsMeta } from "/vercel/path1/pages/set-up-maintenance.vue?macro=true";
import { default as _91slug_93VdFtV3g1p4C0aBlaiNE_oJtPGyEYzdMt5N3ilPAaa_450Meta } from "/vercel/path1/pages/products/type/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path1/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/vercel/path1/pages/[slug].vue")
  },
  {
    name: "distributor",
    path: "/distributor",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path1/pages/distributor.vue")
  },
  {
    name: "find-a-dealer",
    path: "/find-a-dealer",
    component: () => import("/vercel/path1/pages/find-a-dealer.vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug()",
    component: () => import("/vercel/path1/pages/products/[slug].vue")
  },
  {
    name: "community-slug",
    path: "/community/:slug()",
    component: () => import("/vercel/path1/pages/community/[slug].vue")
  },
  {
    name: "set-up-maintenance",
    path: "/set-up-maintenance",
    component: () => import("/vercel/path1/pages/set-up-maintenance.vue")
  },
  {
    name: "products-type-slug",
    path: "/products/type/:slug()",
    component: () => import("/vercel/path1/pages/products/type/[slug].vue")
  }
]